<template>
  <div class="px-2 d-flex justify-content-between" :style="styles">
    <div>{{ info }}
        <span v-if="(marcacao && marcacao.id_solicitacao_autorizacao)">
            - S{{ marcacao.id_solicitacao_autorizacao }}
        </span>
        <span v-if="(marcacao && marcacao.plano && marcacao.plano.st_plano)">
            - {{ marcacao.plano.st_plano }}
        </span>
        <template v-if="pageIndex"> &nbsp;&nbsp;{{pageIndex}} de {{pageCount}}</template>
    </div>
    <div v-if="id_guia">
      <div v-if="id_atendimento"> 
        <barcode :value="'A' + id_atendimento" :displayValue="false" :height="20" :margin="1">
          BC: A{{ id_atendimento }}
        </barcode>
      </div>

      <div v-else>
        <barcode :value="'G' + id_guia" :displayValue="false" :height="20" :margin="1">
          BC: G{{ id_guia }}
        </barcode>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: ""
    };
  },
  props: ["infoId", "idExterno", "responsavel", "large", "pageIndex", "pageCount", "noresize", "id_guia", "id_atendimento", "marcacao"],
  methods: {
    unidade_nome() {
      if (
        this.$store.state.user &&
        this.$store.state.user.id_unidade_operacao
      ) {
        let unidade = this.$store.state.unidade.unidade_operacaos.find(
          item =>
            item.id_unidade_operacao ==
            this.$store.state.user.id_unidade_operacao
        );
        return unidade ? ("- " + (unidade.st_sigla ? unidade.st_sigla : unidade.st_nome )) : "";
      } else { 
        return ( this.marcacao && this.marcacao.unidade_operacao && this.marcacao.unidade_operacao.st_sigla ) 
          ? '- ' + this.marcacao.unidade_operacao.st_sigla
          : '';
      }
    },
    nome_responsavel() {
      if (!this.responsavel) {
        return "usuário: " + this.$store.state.user.st_login;
      }
      return "responsável: " + this.responsavel;
    },
    info_id() {
      let valor = this.infoId;

      if (this.idExterno) {
        valor = valor + " - " + this.idExterno;
      }

      return valor;
    },

    montar() { 
      this.info = `${this.$util.getFormatDate(
        this.$util.hoje()
      )} ${this.$util.agora()}  -  ${this.nome_responsavel()} ${this.unidade_nome()} - #${
        this.info_id()
      }`;
    },
  },

  watch: { 
    infoId: function () { 
      this.montar();
    }
  },

  computed: {
    styles(){

      if ( this.noresize ) { 

        return {};

      } else if( this.large ) {

        return{
            'fontSize': '12pt'
        }

      }

      return {
        'fontSize': '8pt',
      }
    }

  },

  mounted() {
    this.montar();
  }
};
</script>
